module.exports = __webpack_public_path__ + "img/s6.bb20c8db.svg";